<section class="page">
  <header class="page-header">
    <h2>Lots de cartouches</h2>
    <p class="subtitle">Créez, modifiez et supprimez les lots utilisés par les capteurs.</p>
  </header>

  @if (success) {
    <p class="success">{{ success }}</p>
  }

  @if (error) {
    <p class="error">{{ error }}</p>
  }

  <div class="forms-grid">
    @if (showCreateSection) {
      <form class="panel" (ngSubmit)="createLot()">
        <h3>Créer un lot</h3>
        <label for="nouveau-nom">Nom</label>
        <input id="nouveau-nom" name="nouveauNom" [(ngModel)]="nouveauNom" maxlength="100" required />

        <label for="nouvelle-date">Date de réception</label>
        <input id="nouvelle-date" class="native-date" type="date" name="nouvelleDate" [(ngModel)]="nouvelleDate" />

        <label for="nouveau-nombre-cartouches">Nombre de cartouches</label>
        <input id="nouveau-nombre-cartouches" name="nouveauNombreCartouches" type="number" min="0" [(ngModel)]="nouveauNombreCartouches" />

        <button type="submit" [disabled]="loading">Créer</button>
      </form>
    }

    @if (showEditSection) {
      <form class="panel" (ngSubmit)="renameLot()">
        <h3>Modifier un lot</h3>
        <label for="select-lot">Lot</label>
        <select id="select-lot" name="selectedId" [(ngModel)]="selectedId" (ngModelChange)="onSelectChange()">
          <option value="">-- sélectionner --</option>
          @for (lot of lots; track lot.id) {
            <option [value]="lot.id">{{ lot.nom }}</option>
          }
        </select>

        <label for="nom-edition">Nouveau nom</label>
        <input id="nom-edition" name="nomEdition" [(ngModel)]="nomEdition" maxlength="100" required />


        <label for="date-edition">Date de réception</label>
        <input id="date-edition" class="native-date" type="date" name="dateEdition" [(ngModel)]="dateEdition" />

        <label for="nombre-cartouches-edition">Nombre de cartouches</label>
        <input id="nombre-cartouches-edition" name="nombreCartouchesEdition" type="number" min="0" [(ngModel)]="nombreCartouchesEdition" />

        @if (pageMode === 'gerer') {
          <div class="actions">
            <button type="submit" [disabled]="loading">Enregistrer</button>
            <button type="button" class="danger" (click)="deleteLot()" [disabled]="loading || !selectedId">Supprimer</button>
          </div>
        } @else {
          <button type="submit" [disabled]="loading">Enregistrer</button>
        }
      </form>
    }
  </div>

  @if (showListSection) {
    <section class="panel">
      <h3>Liste des lots</h3>
      @if (loadingList) {
        <p>Chargement des lots...</p>
      } @else if (lots.length === 0) {
        <p>Aucun lot disponible.</p>
      } @else {
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nom</th>
                  <th>Date de réception</th>
                  <th>Nombre de cartouches</th>
                @if (showDeleteActionsInTable) {
                  <th>Actions</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (lot of lots; track lot.id) {
                <tr>
                  <td>{{ lot.id }}</td>
                  <td>{{ lot.nom }}</td>
                  <td>{{ lot.date_reception ? (lot.date_reception | date:'dd/MM/yyyy') : '-' }}</td>
                  <td>{{ lot.nombre_cartouches}}</td>
                  @if (showDeleteActionsInTable) {
                    <td class="actions-cell">
                      <button
                        type="button"
                        class="danger"
                        [disabled]="loading || deletingLotId === lot.id"
                        (click)="deleteLotRow(lot)"
                      >
                        {{ deletingLotId === lot.id ? 'Suppression...' : 'Supprimer' }}
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </section>
  }
</section>
